"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemSectionContainer = void 0;
const constants_1 = require("../../constants");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.RedeemSectionContainer = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 5%;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and ${constants_1.Device.laptop} {
        flex-direction: column;
    }
    @media screen and ${constants_1.Device.mobileL} {
        font-size: 14px;
    }
    > div {
        flex: 1;
    }
    .ecrrs-left {
        overflow: hidden;
        img {
            width: 100%;
        }
    }
    .ecrrs-right {
        max-width: 800px;
        padding: 3%;
        margin-left: 2em;
    }
    button {
        outline: none;
        border: none;
    }
`;
const RedeemSectionContainerExtended = (_a) => {
    var { className = '', children } = _a, rest = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(exports.RedeemSectionContainer, Object.assign({ className: className }, rest), children));
};
exports.default = RedeemSectionContainerExtended;
//# sourceMappingURL=RedeemSectionContainer.js.map